// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__2xbRY","tableHeader":"Table_tableHeader__J1xrJ","tableCell":"Table_tableCell__2OAMM","fadeIn":"Table_fadeIn__1EC8C","fadeOut":"Table_fadeOut__1yU-b"};